// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-checkbox input {
    width: 21px;
    height: 21px;
}

.admin-checkbox {
    height: 20px;
}

.admin-switch {
    width: 50px;
    height: 24px;
}

.admin-switch input {
    width: 0;
    height: 0;
}

.admin-slider {
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: all 0.4s;
}

.admin-slider.admin-round {
    border-radius: 34px;
}

.admin-slider.admin-round:before {
    border-radius: 50%;
}

.admin-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 4px;
    bottom: 0.2rem;
    transition: all 0.2s;
}

input:checked+.admin-slider:before {
    left: 28px;
}

.heightOnLoader {
    height: calc(100vh - 170px);
}

.indicator-on-off {
    position: absolute;
    top: 5px;
    z-index: 0;
    font-size: 10px;
    font-weight: 500;
}

.indicator-on-off.on {
    left: 9px;
}

.indicator-on-off.off {
    right: 7px;
}

.payment-mode-custom-select {
    height: 30px;
    max-width: 65px !important;
    padding: 2px 6px !important;
}

.append-text {
    align-items: center;
    border-bottom-left-radius: 7px;
    border-top-left-radius: 7px;
    display: flex;
    height: 46px;
    left: 2px;
    padding: 7px 18px;
    position: absolute;
    top: 2px;
}

.append-text-padding {
    padding-left: 263px !important;
}

.pop-up-admin-heading {
    border-radius: 33px;
    padding: 3px 9px;
}

.currency-settings-flag {
    top: 9px;
    right: 11px;

}

.slider-image-banner {
    width: 100%;
    max-width: 140px;
    height: 75px;
}

.disabled-switch {
    opacity: 0.6;
}

.disabled-switch .admin-slider,
.disabled-switch .indicator-on-off {
    cursor: not-allowed;
    pointer-events: none;
}

.spinner-overlay {
    position: absolute;
    top: 50%;
    right: 70px;
    transform: translate(10px, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

.spinner {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: #007bff;
    /* Primary Blue */
    border-radius: 50%;
    animation: spin 0.8s ease-in-out infinite;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
}

.spinner-overlay-ai {
    position: absolute;
    top: 98%;
    transform: translate(10px, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

.spinner-ai {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 0.8s ease-in-out infinite;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
}

.ImageUploadContainer {
    width: 100px;
    height: 62px;
    position: relative;
    border: 1.5px dashed #ccc;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fafbfc;
}

.ImageUploadContainer.portrait {
    width: 100px;
    height: 75px;
}

.ImageUploadContainer.landscape {
    width: 100px;
    height: 75px;
}

.AdminImageUploader {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    inset: 0;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CommonComponents/Admin.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".admin-checkbox input {\n    width: 21px;\n    height: 21px;\n}\n\n.admin-checkbox {\n    height: 20px;\n}\n\n.admin-switch {\n    width: 50px;\n    height: 24px;\n}\n\n.admin-switch input {\n    width: 0;\n    height: 0;\n}\n\n.admin-slider {\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.6s;\n    transition: all 0.4s;\n}\n\n.admin-slider.admin-round {\n    border-radius: 34px;\n}\n\n.admin-slider.admin-round:before {\n    border-radius: 50%;\n}\n\n.admin-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    left: 4px;\n    bottom: 0.2rem;\n    transition: all 0.2s;\n}\n\ninput:checked+.admin-slider:before {\n    left: 28px;\n}\n\n.heightOnLoader {\n    height: calc(100vh - 170px);\n}\n\n.indicator-on-off {\n    position: absolute;\n    top: 5px;\n    z-index: 0;\n    font-size: 10px;\n    font-weight: 500;\n}\n\n.indicator-on-off.on {\n    left: 9px;\n}\n\n.indicator-on-off.off {\n    right: 7px;\n}\n\n.payment-mode-custom-select {\n    height: 30px;\n    max-width: 65px !important;\n    padding: 2px 6px !important;\n}\n\n.append-text {\n    align-items: center;\n    border-bottom-left-radius: 7px;\n    border-top-left-radius: 7px;\n    display: flex;\n    height: 46px;\n    left: 2px;\n    padding: 7px 18px;\n    position: absolute;\n    top: 2px;\n}\n\n.append-text-padding {\n    padding-left: 263px !important;\n}\n\n.pop-up-admin-heading {\n    border-radius: 33px;\n    padding: 3px 9px;\n}\n\n.currency-settings-flag {\n    top: 9px;\n    right: 11px;\n\n}\n\n.slider-image-banner {\n    width: 100%;\n    max-width: 140px;\n    height: 75px;\n}\n\n.disabled-switch {\n    opacity: 0.6;\n}\n\n.disabled-switch .admin-slider,\n.disabled-switch .indicator-on-off {\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n.spinner-overlay {\n    position: absolute;\n    top: 50%;\n    right: 70px;\n    transform: translate(10px, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n}\n\n.spinner {\n    width: 24px;\n    height: 24px;\n    border: 3px solid rgba(0, 0, 0, 0.1);\n    border-top-color: #007bff;\n    /* Primary Blue */\n    border-radius: 50%;\n    animation: spin 0.8s ease-in-out infinite;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);\n}\n\n.spinner-overlay-ai {\n    position: absolute;\n    top: 98%;\n    transform: translate(10px, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n}\n\n.spinner-ai {\n    width: 24px;\n    height: 24px;\n    border: 3px solid rgba(0, 0, 0, 0.1);\n    border-top-color: #007bff;\n    border-radius: 50%;\n    animation: spin 0.8s ease-in-out infinite;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);\n}\n\n.ImageUploadContainer {\n    width: 100px;\n    height: 62px;\n    position: relative;\n    border: 1.5px dashed #ccc;\n    border-radius: 8px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #fafbfc;\n}\n\n.ImageUploadContainer.portrait {\n    width: 100px;\n    height: 75px;\n}\n\n.ImageUploadContainer.landscape {\n    width: 100px;\n    height: 75px;\n}\n\n.AdminImageUploader {\n    z-index: 1;\n    cursor: pointer;\n    position: absolute;\n    inset: 0;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
